import { styled } from "../../../styles";

/**
 * Surveys & PROMs page styles (EN-5164). Generic admin chrome lives in
 * `shared/AdminPage.styles.ts`.
 */

export const ModalBodyText = styled("p", {
  margin: 0,
  fontSize: "14px",
  lineHeight: 1.5,
  color: "$charcoal",
  fontFamily: "$openSans",
});

/** Per-row text button in a table's action column. */
export const RowActions = styled("div", {
  display: "flex",
  gap: "6px",
  justifyContent: "flex-end",
});

/** Chip list of the survey names configured on a ward. */
export const SurveyNameTags = styled("span", {
  display: "inline-flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "4px",
});

export const SurveyNameTag = styled("span", {
  padding: "2px 8px",
  borderRadius: "999px",
  border: "1px solid $gray-50",
  backgroundColor: "$white",
  color: "$gray-100",
  fontSize: "12px",
  fontFamily: "$openSans",
  // Long survey titles ("Modified 7-day Lee Symptom Scale (mLSS)") would
  // otherwise decide how wide this column gets.
  maxWidth: "220px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  variants: {
    /** The "+N more" pill — a count, not one of the names. */
    more: {
      true: {
        borderColor: "$primary-30",
        backgroundColor: "$primary-20",
        color: "$primary-80",
        cursor: "default",
      },
    },
  },
});

/** One question in the answer editor. */
export const QuestionCard = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "12px 14px",
  borderRadius: "8px",
  border: "1px solid $gray-30",
  backgroundColor: "$white",

  variants: {
    /** An answer changed but not yet saved. */
    edited: {
      true: {
        borderColor: "$warning",
        backgroundColor: "$warning-lightest",
      },
    },
  },
});

export const QuestionText = styled("span", {
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: 600,
  color: "$charcoal",
});

export const QuestionMeta = styled("span", {
  fontFamily: "$openSans",
  fontSize: "11px",
  color: "$gray-60",
});

export const QuestionList = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

/** Radio/checkbox row inside a question card. */
export const OptionRow = styled("label", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$charcoal",
  cursor: "pointer",

  "& input": {
    accentColor: "$primary",
    cursor: "pointer",
  },
});

/**
 * A question type the editor can't edit (Media, Informative and the bespoke
 * SupOx set). Retool rendered no control for these either — the value is
 * shown read-only rather than silently dropped.
 */
export const ReadOnlyAnswer = styled("span", {
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$gray-80",
  fontStyle: "italic",
});

/** Footer of the answer editor: a divider, then the count and the actions. */
export const EditorActions = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  paddingTop: "16px",
  borderTop: "1px solid $gray-30",
});

export const EditorActionButtons = styled("div", {
  display: "flex",
  gap: "8px",
});
